// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__t8Xlc"};